import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  UserCourseListComponent,
  SafePipe
} from './user-course-list.component';
import { SharedModule } from '../../../@hornbillfx/components/shared.module';
import { RouterModule } from '@angular/router';

// Pages Globaly required Components - Optional
import { pgTabsModule } from './../../../@hornbillfx/components/tabs/tabs.module';
import { pgSwitchModule } from './../../../@hornbillfx/components/switch/switch.module';
import { ProgressModule } from './../../../@hornbillfx/components/progress/progress.module';
import { MessageModule } from '../../../@hornbillfx/components/message/message.module';
import { MessageService } from '../../../@hornbillfx/components/message/message.service';

@NgModule({
   imports: [
      CommonModule,
      SharedModule,
      RouterModule,
      pgTabsModule,
      pgSwitchModule,
      ProgressModule,
      MessageModule
   ],
   declarations: [
      UserCourseListComponent,
      SafePipe,
   ],
   providers:[MessageService]
})
export class UserCourseListModule {}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-course/user-course-list/user-course-list.module.ts